import { useApplication } from '@bonusly/application';

const knownMonarchOrigins = new Set(['https://app.bonus.ly', 'https://app-staging.bonus.ly', 'http://localhost:3003']);

const resolveOrigin = (origin: string | undefined, currentOrigin: string) => {
	if (!origin) return '';

	try {
		return new URL(origin, currentOrigin).origin;
	} catch {
		return '';
	}
};

export const useIsRecognize = () => {
	const monarchOrigin = useApplication((state) => state.application.get('monarchOrigin', { allowEmpty: true }));
	const urlOrigin = window.location.origin;
	const urlPath = window.location.pathname;
	const configuredMonarchOrigin = resolveOrigin(monarchOrigin, urlOrigin);

	const isMonarch =
		configuredMonarchOrigin === urlOrigin ||
		knownMonarchOrigins.has(urlOrigin) ||
		(urlOrigin === 'https://bonus.ly' && urlPath.startsWith('/app')) ||
		(urlOrigin === 'https://staging.bonus.ly' && urlPath.startsWith('/app'));

	return !isMonarch;
};
